<app-page-header title="Home" active_item="Transferência" titleLink="/reports"  ></app-page-header>
<div class="loading-transferencia" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ 'common.pixTransfer' | translate }}</h5>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.paymentData' | translate }}</div>
      </div>
      <div class="card-body">
        <div class="alert alert-dark text-center" role="alert">
          <b
            >{{ 'common.availableBalance' | translate }}:
            {{
              saldoDisponivel
                | formatCurrency
            }}</b
          >
        </div>
        <form [formGroup]="saque">
          <div class="row">
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="slTipoChavePix" class="form-label"
                  >{{ 'common.pixKeyType' | translate }} <span class="text-danger">*</span></label
                >
                <ng-select
                  id="slTipoChavePix"
                  [clearable]="false"
                  [searchable]="false"
                  [items]="tiposChavePix"
                  bindValue="id"
                  bindLabel="value"
                  [formControl]="saque.controls.tipoChave"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.tipoChave.invalid && isSubmitted
                  }"
                />
                <div class="invalid-feedback">{{ tipoChaveFeedBack }}</div>
              </div>
            </div>
            <div class="col-xl-5 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtChavePix" class="form-label"
                  >{{ 'common.pixKey' | translate }} <span class="text-danger">*</span></label
                >
                <div class="input-icon-container">
                  <input
                  class="form-control"
                  type="text"
                  [formControl]="saque.controls.chavePix"
                  name="chavePix"
                  id="txtChavePix"
                  *ngIf="saque.controls.tipoChave.value === ''"
                  [readonly]="true"
                  />
                  <i (click)="pastePixKey()" class="fe fe-copy input-icon"></i>
                
                  <input
                  class="form-control"
                  type="text"
                  mask="000.000.000-00"
                  [formControl]="saque.controls.chavePixCpfCnpj"
                  name="chavePix"
                  *ngIf="saque.controls.tipoChave.value === 'CPF'"
                  [ngClass]="{
                    'is-invalid state-invalid':
                    saque.controls.chavePixCpfCnpj.invalid && isSubmitted
                  }"
                  [readonly]="openConfirm"
                  />                

                <input
                  class="form-control"
                  type="text"
                  mask="00.000.000/0000-00"
                  [formControl]="saque.controls.chavePixCpfCnpj"
                  name="chavePix"
                  *ngIf="saque.controls.tipoChave.value === 'CNPJ'"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.chavePixCpfCnpj.invalid && isSubmitted
                  }"
                  [readonly]="openConfirm"
                />

                
                <input
                  class="form-control"
                  type="text"
                  [formControl]="saque.controls.chavePixEmail"
                  name="chavePix"
                  *ngIf="saque.controls.tipoChave.value === 'EMAIL'"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.chavePixEmail.invalid && isSubmitted
                  }"
                  [readonly]="openConfirm"
                />
                <input
                  class="form-control"
                  type="text"
                  mask="(00) 000000000"
                  [formControl]="saque.controls.chavePix"
                  name="chavePix"
                  *ngIf="saque.controls.tipoChave.value === 'PHONE'"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.chavePix.invalid && isSubmitted
                  }"
                  [readonly]="openConfirm"
                />
                <input
                  class="form-control"
                  type="text"
                  [formControl]="saque.controls.chavePix"
                  name="chavePix"
                  *ngIf="saque.controls.tipoChave.value === 'EVP'"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.chavePix.invalid && isSubmitted
                  }"
                  [readonly]="openConfirm"
                />
                <div class="invalid-feedback">{{ chavePixFeedBack }}</div>
                </div>
              </div>
            </div>
            <div class="col-xl-5 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorSolicitado" class="form-label"
                  > {{ 'common.recipientDocument' | translate }} <span class="text-danger">*</span></label
                >
                <div class="input-icon-container">
                  <input mask="CPF_CNPJ" [formControl]="saque.controls.documentoRecebedor" class="form-control" type="text" name="documentoRecebedor" id="txtDocumentoRecebedor" [ngClass]="{'is-invalid state-invalid': saque.controls.documentoRecebedor.invalid && isSubmitted}">
                  <div class="invalid-feedback">{{ documentoFeedBack }}</div>
                  <i (click)="pasteDocument()" class="fe fe-copy input-icon"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorSolicitado" class="form-label"
                  >{{ 'common.requestedValue' | translate }}  <span class="text-danger">*</span></label
                >
                <input
                  placeholder="{{0 | formatCurrency }}"
                  [formControl]="saque.controls.valorSolicitado"
                  currencyMask
                  [options]="{ prefix: ('' | currencySymbol) + ' ' }"
                  class="form-control"
                  type="text"
                  name="valorSolicitado"
                  id="txtValorSolicitado"
                  (focusout)="valorSolicitadoChanged()"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      saque.controls.valorSolicitado.invalid && isSubmitted
                  }"
                />
                <div class="invalid-feedback">{{ valorFeedBack }}</div>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtTaxa" class="form-label">{{ 'common.fee' | translate }} </label>
                <input
                  [prefix]="( '' | currencySymbol ) + ' '"
                  [formControl]="saque.controls.taxa"
                  mask="separator.2"
                  [leadZero]="true"
                  decimalMarker=","
                  thousandSeparator="."
                  class="form-control"
                  type="text"
                  name="taxa"
                  id="txtTaxa"
                  [readonly]="true"
                />
              </div>
            </div>
            <div class="col-xl-5 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorTotal" class="form-label"
                  >{{ 'common.totalAmount' | translate }} </label
                >
                <input
                  [prefix]="( '' | currencySymbol ) + ' '"
                  [formControl]="saque.controls.valorTotal"
                  mask="separator.2"
                  [leadZero]="true"
                  decimalMarker=","
                  thousandSeparator="."
                  class="form-control"
                  type="text"
                  name="valorTotal"
                  id="txtValorTotal"
                  [readonly]="true"
                />
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="openDataConfirm()"
              >
                <i class="fe fe-arrow-up-right"></i>{{ 'common.transferButton' | translate }} 
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="openConfirm">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.confirmData' | translate }}</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xl-6 col-lg-12 col-sm-12">
            <div class="form-group">
              <label for="txtNomeProprietario" class="form-label"
                >{{ 'common.recipient' | translate }}</label
              >
              <input
                [(ngModel)]="dictResponse.nomeProprietario"
                class="form-control"
                type="text"
                name="valorSolicitado"
                id="txtNomeProprietario"
                [readonly]="true"
              />
            </div>
          </div>
          <div class="col-xl-5 col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="txtDocumentoRecebedor" class="form-label"
                >{{ 'common.recipientDocument' | translate }}
              </label>
              <input
                [(ngModel)]="dictResponse.identificadorProprietario"
                class="form-control"
                type="text"
                name="valorSolicitado"
                id="txtDocumentoRecebedor"
                [readonly]="true"
              />
            </div>
          </div>
          <div class="col-xl-1 col-lg-6 col-sm-6">
            <button
              type="button"
              class="our-button btn btn-pill btn-primary"
              (click)="makeWithdraw()"
            >
              <i class="fe fe-arrow-up-right"></i>{{ 'common.confirmButton' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{'login.totp.pasteButton' | translate}}
      </button>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
